export class Applicationdate {
    Id: number;
    BranchId: number;
    CurrentDate: Date;
    ApplicationDate: Date;
    Remarks: string;

    EmployeeId  : number;
    EmployeeBranchId  : number;
    CompanyId  : number;
    SaasId  : number;
    CreatedDate  : Date;
    ModifiedDate  : Date;
    IsActive : boolean;
    Flag: Number;
}
